/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const DotsVertical: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="6" r="2" transform="rotate(90 12 6)" fill={color}/>
    <circle cx="12" cy="12" r="2" transform="rotate(90 12 12)" fill={color}/>
    <circle cx="12" cy="18" r="2" transform="rotate(90 12 18)" fill={color}/>
  </svg>
}
